import { MmdModelLoader } from "./mmdModelLoader";
import { MmdStandardMaterialBuilder } from "./mmdStandardMaterialBuilder";
MmdModelLoader.SharedMaterialBuilder = new MmdStandardMaterialBuilder();
